/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detatched_Scroll_DownInputs */

const en_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll Down`)
};

const ar_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرر للأسفل`)
};

const bn_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিচে স্ক্রল করুন`)
};

const de_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach unten scrollen`)
};

const es_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazarse hacia abajo`)
};

const fr_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faites défiler vers le bas`)
};

const pt_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role para baixo`)
};

const zh_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下滚动`)
};

const tr_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aşağı Kaydır`)
};

const ru_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прокрутите вниз`)
};

const pl_detatched_scroll_down = /** @type {(inputs: Detatched_Scroll_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przewiń w dół`)
};

/**
* | output |
* | --- |
* | "Scroll Down" |
*
* @param {Detatched_Scroll_DownInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const detatched_scroll_down = /** @type {((inputs?: Detatched_Scroll_DownInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detatched_Scroll_DownInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_detatched_scroll_down(inputs)
	if (locale === "bn") return bn_detatched_scroll_down(inputs)
	if (locale === "de") return de_detatched_scroll_down(inputs)
	if (locale === "es") return es_detatched_scroll_down(inputs)
	if (locale === "fr") return fr_detatched_scroll_down(inputs)
	if (locale === "pt") return pt_detatched_scroll_down(inputs)
	if (locale === "zh") return zh_detatched_scroll_down(inputs)
	if (locale === "tr") return tr_detatched_scroll_down(inputs)
	if (locale === "ru") return ru_detatched_scroll_down(inputs)
	if (locale === "pl") return pl_detatched_scroll_down(inputs)
	return en_detatched_scroll_down(inputs)
});